import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Card, Input, Select, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { healthRecordTypesRequest, healthRecordUploadRequest } from './Actions';
import { selectHealthRecordTypes, selectHealthRecordTypeSuccess, selectLoading } from './Selectors';
import CustomSpin from '../CommonSpin';
import { Content } from 'antd/es/layout/layout';
import { BodyTextHeadingSmall, ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Option } = Select;

const HealthRecUpload = () => {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [selectValue, setSelectValue] = useState(null);

    const navigate = useNavigate();

    const recordTypes = useSelector(selectHealthRecordTypes);
    const success = useSelector(selectHealthRecordTypeSuccess);
    const requesting = useSelector(selectLoading);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    
    if(success) {
        navigate('/record');
    }
    
    useEffect(() => {
        // dispatch({ type: HEALTH_REC_TYPES }); // Dispatch action to get record types
        dispatch(healthRecordTypesRequest());
    }, []);

    const handleFileChange = e => {
        if (e.target.files[0] !== null) {
            const fileType = e.target.files[0].type;
            if (fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'application/pdf') {
                setFile(e.target.files[0]);
            }
        }
    };

    const handleSelectChange = value => {
        setSelectValue(value);
        localStorage.setItem('HEALTH_TYPE_ID', value);
    };

    const handleSave = () => {
        if (selectValue !== null && file !== null) {
            // dispatch({ type: HEALTH_REC_UPLOAD, payload: { file, selectValue } });
            dispatch(healthRecordUploadRequest({payload: { file, selectValue } }));
            
        } else {
            Modal.warning({
                title: 'Please select all fields',
            });
        }
    };

    const handleCancel = () => {
        navigate('/record');
    };

    return (
        <Content>
            <div>
                <Row type="flex" justify="center" style={{ marginTop: '10px' }}>
                    <Col
                        xs={{ span: 10 }}
                        md={{ span: 10 }}
                        lg={{ span: 10 }}
                        xl={{ span: 12 }}
                        xxl={{ span: 12 }}
                    >
                        <Card style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)', borderRadius: '4px', marginBottom : '10px' }}>
                            <div>
                                <div style={{ marginBottom: '20px' }}>
                                    <BodyTextHeadingSmall text = {`${langdata.SelectTypeOfRecord ? langdata.SelectTypeOfRecord : 'Select Type Of Record'}`} />
                                    <Select
                                        style={{ width: '100%', marginTop : '10px' }}
                                        onChange={handleSelectChange}
                                        placeholder={`${langdata.PleaseSelectHealthRecordType ? langdata.PleaseSelectHealthRecordType : 'Please Select Health Record Type' }`}
                                    >
                                        {recordTypes && recordTypes.data && recordTypes.data.map(item => (
                                            <Option key={item.id} value={item.id}>
                                                {item.healthRecType}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <BodyTextHeadingSmall text = {`${langdata.ChooseFile ? langdata.ChooseFile : 'Choose File'}`} />
                                <Input
                                    type="file"
                                    style={{  marginTop : '10px' }}
                                    name="file"
                                    accept="image/*,application/pdf"
                                    onChange={handleFileChange}
                                />
                                <br />
                                <Button
                                    style={{ marginRight: '8px', marginTop: '30px' }}
                                    onClick={handleCancel}
                                >
                                    <ButtonText text = {`${langdata.Cancel ? langdata.Cancel : 'Cancel' }`}  color = 'black'/>
                                </Button>
                                <Button
                                    style={{ marginTop: '30px' }}
                                    type="primary"
                                    onClick={handleSave}
                                >
                                    <ButtonText text = {`${langdata.Save ? langdata.Save : 'Save' }`} />
                                </Button>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <CustomSpin spinning={requesting} />                
            </div>
        </Content>
    );
};


export default HealthRecUpload;
